import { Length } from "../../../core/Length/Length";
import { DrawCabinetFrontElement } from "./DrawCabinetFrontElement";

export class DrawFrontFrame extends DrawCabinetFrontElement {
    horizontalThickness!: Length;

    verticalThickness!: Length;
}
